import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HttpService } from "../shared/services/http.service";

@Component({
  selector: "app-bulk-code-dialog",
  templateUrl: "./bulk-code-dialog.component.html",
  styleUrls: ["./bulk-code-dialog.component.scss"],
  standalone: false
})
export class BulkCodeDialogComponent implements OnInit {
  @Input() selectedClientIds: any[] = []
  @Input() selectedClients: any[] = []
  @Output() close = new EventEmitter<void>()
  @Output() applied = new EventEmitter<void>()

  stencils: any[] = []
  stencilId = ''
  expectedCompletion = ''
  processing = false

  get selectedCount(): number {
    return this.selectedClientIds.length
  }

  constructor(private httpService: HttpService) {}

  async ngOnInit() {
    const res: any = await this.httpService.getAsync('hcode/getStencils')
    this.stencils = res?.data || []
  }

  selectStencil(event: Event) {
    this.stencilId = (event.target as HTMLSelectElement).value
  }

  async process() {
    if (!this.stencilId || !this.expectedCompletion || this.processing) return
    this.processing = true
    try {
      const responseData: any = await this.httpService.postBlob('hcode/bulkAddCode', {
        clientIds: [...this.selectedClientIds],
        stencilId: this.stencilId,
        expectedCompletion: this.expectedCompletion
      })

      const blob = new Blob([responseData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `Bulk-Add-Code-${this.expectedCompletion}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      this.applied.emit()
    } finally {
      this.processing = false
    }
  }
}
